import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

import {FrontEnvironmentsEnum} from '../../helpers/environment/environments';

export function buildBugsnagOptions(appVersion: string, releaseStage: FrontEnvironmentsEnum) {
  return {
    // Hardcoded secret granted exception by security team: cnv_dylu16r?key=u2Tj8vk0kKZ6Z_R7FfWJX0htRiU_Zon4
    apiKey: '9e0d190bd69662be37bc0659aca27a1a',
    appVersion,
    releaseStage,

    autoTrackSessions: false,
    redactedKeys: [/^(authorization|x-front-xsrf|password)$/i],
    plugins: [new BugsnagPluginReact(React)],
  };
}
